function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon-pdf_svg__cls-2{fill:none;stroke:var(--main-color);stroke-linecap:round;stroke-linejoin:round;stroke-width:8px}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "icon-pdf_svg__Layer_1",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M192.41 55a4.6 4.6 0 014.59 4.59v130.82a4.6 4.6 0 01-4.59 4.59H61.59a4.6 4.6 0 01-4.59-4.59V59.59A4.6 4.6 0 0161.59 55h130.82m0-8H61.59A12.59 12.59 0 0049 59.59v130.82A12.59 12.59 0 0061.59 203h130.82A12.59 12.59 0 00205 190.41V59.59A12.59 12.59 0 00192.41 47z",
  fill: "var(--main-color)"
}), /*#__PURE__*/React.createElement("path", {
  className: "icon-pdf_svg__cls-2",
  d: "M99 104h50M99 147h50"
}), /*#__PURE__*/React.createElement("path", {
  d: "M197 196c-24-8-30-21-30-21s27.68-19.51 34-81",
  fillRule: "evenodd",
  stroke: "var(--main-color)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 8,
  fill: "var(--main-color)"
}));

function SvgIconPdf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 259 259"
  }, props), _ref, _ref2);
}

export default SvgIconPdf;